import { createSelector } from 'reselect';
import { StoryModel } from 'types/story';
import { StoryFacade } from 'common/utils/facades/story-facade';
import { getAvailableVariables } from 'common/utils/variables/variables';
import { ClientReducerState } from 'client/reducers';
import { selectCardId } from 'client/reducers/card/selectors';

export const selectStory = (state: ClientReducerState) => state.story;

export const selectStorySettings = createSelector(
	selectStory,
	story => story.storyVersions?.[StoryFacade.VERSIONS.latest].settings
);

export const selectStoryCardSettings = createSelector(
	[selectStorySettings, (state: ClientReducerState, cardId?: string) => cardId ?? selectCardId(state)],
	(storySettings, cardId) =>
		storySettings !== undefined && cardId !== undefined ? storySettings.cards?.[cardId] : undefined
);

// select available story variables list (no values)
export const selectStoryVariables = createSelector([selectStory], story =>
	getAvailableVariables({ story: story as StoryModel })
);
